const actors = {
  enbridge: 'Enbridge',
};

const button = {
  cancel: 'Cancel',
  confirm: 'Confirm',
  create: 'Create',
  save: 'Save',
};

const entity = {
  client: 'Client',
  mission: 'Mission',
  report: 'Report',
  dictionary: 'Dictionary',
};

const message = {
  error: {
    global: 'An error occurred, please try again!',
    signalr: 'An error occured with SignalR',
  },
  errorWithSystem: 'There was an error with this system:',
  pageNotFound: 'Page not found',
  requiredField: 'Required field',
  success: {
    deleted: '$t(common.entity.{{entity}}) successfully deleted',
    downloaded: '$t(common.entity.{{entity}}) successfully downloaded',
    uploaded: '$t(common.entity.{{entity}}) successfully uploaded',
    copiedToClipboard: 'Successfully copied to clipboard!',
  },
  technicalSupport: 'Please contact your technical support for assistance.',
};

const menu = {
  navigationBar: {
    clients: 'Clients',
    missions: 'Missions',
    reports: 'Reports',
  },
};

const userInterface = {
  noDataToDisplay: 'No data to display',
  noModificationsToSave: 'No modifications to save',
  unsavedModifications: 'Please save modifications',
};

export default {
  actors,
  button,
  entity,
  menu,
  message,
  no: 'No',
  search: 'Search...',
  userInterface,
  yes: 'Yes',
};
